export default "__VITE_ASSET__a9xBF1$$__"